import React, { useEffect } from 'react';
import { Box, ButtonBase } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { INK } from '../instrument';

/**
 * The Health tab's two views (2026-11-03, Jason: Supplements had no clear way in).
 * Supplements and Labs share one tab with this switch, like Training | Recovery
 * under Exercise. The tab opens whichever view was used last.
 */
export const HEALTH_VIEW_KEY = 'ft_health_view';
export const healthTabPath = (): string => {
  try { return localStorage.getItem(HEALTH_VIEW_KEY) === 'labs' ? '/bloodwork' : '/supplements'; } catch { return '/supplements'; }
};

const HealthViewSwitch: React.FC<{ view: 'supplements' | 'labs' }> = ({ view }) => {
  const navigate = useNavigate();
  useEffect(() => { try { localStorage.setItem(HEALTH_VIEW_KEY, view); } catch { /* ignore */ } }, [view]);
  const item = (key: 'supplements' | 'labs', label: string, path: string) => {
    const on = view === key;
    return (
      <ButtonBase
        onClick={() => !on && navigate(path)}
        aria-current={on ? 'page' : undefined}
        sx={{ flex: 1, minHeight: 40, borderRadius: '8px', fontFamily: 'Inter, sans-serif', fontSize: '0.9rem', fontWeight: 600, color: on ? INK.cyan : 'rgba(255,255,255,0.65)', background: on ? 'rgba(0,224,255,0.16)' : 'transparent' }}
      >
        {label}
      </ButtonBase>
    );
  };
  return (
    <Box role="navigation" aria-label="Health views" sx={{ display: 'flex', gap: 0.25, p: 0.4, mb: 1.5, borderRadius: '10px', background: INK.card, border: '1px solid rgba(255,255,255,0.08)', maxWidth: 480 }}>
      {item('supplements', 'Supplements', '/supplements')}
      {item('labs', 'Labs', '/bloodwork')}
    </Box>
  );
};

export default HealthViewSwitch;
